import { API_WEBSITE } from '@commons/utils/constants';

/**
 * Constant to determine if the website is multilingual.
 *
 * For now, only Crisis24 and Aiia are multilingual.
 */

export const IS_MULTILINGUAL = ['crisis24', 'aiia'].includes(API_WEBSITE);

/**
 * Enum of the available locales.
 *
 * Useful when used in a data structure or logic statement.
 * By using an enum, we minimize the impact of potential locale changes in the future.
 */

export enum LOCALES {
  EN = 'en',
  FR = 'fr',
  JA = 'ja',
}

/**
 * Array of all available locales.
 */

export let AVAILABLE_LOCALES = [LOCALES.EN];

if (API_WEBSITE === 'aiia') {
  AVAILABLE_LOCALES = [LOCALES.EN, LOCALES.FR];
}

if (API_WEBSITE === 'crisis24') {
  AVAILABLE_LOCALES = Object.values(LOCALES);
}

/**
 * Default locale constant.
 */

export const DEFAULT_LOCALE = LOCALES.EN;

/**
 * Get the home alias for a given locale.
 *
 * @param locale - The locale to get the home alias for.
 *
 * @returns The home alias for the given locale.
 */

export const getHomeAliasByLocale = (locale: LOCALES) => {
  switch (locale) {
    case LOCALES.FR:
      return '/accueil';
    default:
      return '/home';
  }
};

/**
 * Type definition of the alternates object.
 *
 * This type is voluntarily simple, as TypeScript is not able to infer the key properly.
 */

export type Alternates = Record<string, string>;

/**
 * Object with the default alternates for each non-regionalized locale.
 */

export const DEFAULT_ALTERNATES: Alternates = IS_MULTILINGUAL
  ? {
      [LOCALES.EN]: '/',
      [LOCALES.FR]: '/',
      [LOCALES.JA]: '/',
    }
  : {
      [LOCALES.EN]: '/',
    };
